import * as React from 'react';
import { LinkedText } from './LinkedText';
import type { WhyUsFaq } from '../../types/whyus-landing';

interface FaqSectionProps {
  faqs: WhyUsFaq[];
}

export function FaqSection({ faqs }: FaqSectionProps) {
  return (
    <section className="whyus-faq">
      <style>{`
        .whyus-faq {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .whyus-faq-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .whyus-faq h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 28px;
        }
        .whyus-faq-item {
          margin: 0 0 22px;
        }
        .whyus-faq-item h3 {
          font-size: 18px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 6px;
        }
        .whyus-faq-item p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0;
        }
        @media (max-width: 640px) {
          .whyus-faq h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="whyus-faq-inner">
        <h2>Preguntas frecuentes</h2>
        {faqs.map((faq) => (
          <div key={faq.question} className="whyus-faq-item">
            <h3>{faq.question}</h3>
            <p><LinkedText text={faq.answer} /></p>
          </div>
        ))}
      </div>
    </section>
  );
}
